var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order_banner_box"},[_c('div',{class:_vm.banner_bg},[_vm._v(" "+_vm._s(_vm.ch)+" | "+_vm._s(_vm.en)+" ")]),_c('div',{staticClass:"order_banner_more"},[_vm._v(" 查看更多>> ")])])}
var staticRenderFns = []

export { render, staticRenderFns }